<template>
  <q-page padding>   
    <q-card> 
    <q-card-section>
    <div class="row">
      <div class="col">
        <div class="text-h6">{{$t('global.ExcelAnalytics')}}</div>
      </div>
    </div>
    <q-separator/>
    <div class="row">
      <div class="col q-pa-md">
        <q-select v-model="IdReport" :options="excelReportList" 
          :label="$t('global.ExcelReports')" option-value="ExcelReportID" 
          option-label="ReportName"  emit-value map-options ref="RepSelect"/>
      </div>
    </div>
    <div class="row">
      <div class="col q-pa-md">
          <DateInput :date.sync="pDateFrom" :label="$t('global.DateFrom')"></DateInput>
      </div>
      <div class="col q-pa-md">
        <DateInput :date.sync="pDateTo" :label="$t('global.DateTo')"></DateInput>
      </div>
      </div>
      <div class="row">
        <div class="col q-pa-md">
          <q-btn :disable="!IdReport" :label="$t('global.DownloadExcel')" color="primary" @click="run"/>
        </div>
        <div class="col q-pa-md">
          <q-btn v-if="IdReport" :disable="!IdReport" :label="$t('global.DeleteExcelTemplate')" color="primary" @click="deleteExcel" outline/>
        </div>
      </div>
    </q-card-section>
    </q-card>  
    <q-card class="secondCard">
    <q-card-section>
    <div class="row">
      <div class="col">
        <div class="text-h6">{{$t('global.UploadExcelTemplate')}}</div>
      </div>
    </div>
    <q-separator/>
      <div class="row">
        <div class="col q-pa-md">
          <q-input v-model="reportName" :label="$t('global.NewExcelReportName')"></q-input>
        </div>
      <div class="col q-pa-md">
        <q-select
          v-model="selectType"
          :float-label="$t('global.ChangeMap')"     
          :options="selectTypeOptions"
          label="Report Type"
          emit-value map-options
        />
      </div>
      </div>
      <div class="row">
        <div class="col q-pa-md">
        <q-uploader
          :url="uploadUrl"
          :label="$t('global.UploadExcelTemplate')"
          color="primary"
          flat
          bordered
          style="max-width: 300px"
          :form-fields="formfields"   
          accept=".xlsx"
          @added="setUpload"
          @finish="uploaded"
          :disable="!reportName || !selectType"
        />
        </div>
      </div>
    </q-card-section>
    </q-card>
  </q-page>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../main'
export default {
  data () {
    return {
      reportName: '',
      uploadUrl: this.$apiUrlGo + "/upload/",
      form: {},   
      IdReport: null,
      selected: [],
      pDateFrom: this.moment().add(-100, 'days'),
      pDateTo: this.moment(),
      optionReport: [],  
      formfields: [],
      selectType: null,
      selectTypeOptions: [
        {
          label: this.$t('global.Distance') ,
          value: 1
        },
        {
          label: this.$t('global.Alerts') ,
          value: 2
        },
        {
          label: this.$t('global.PointOfInterest') ,
          value: 3
        },
      ],
      excelReportList: [],

    }
  },
  methods: {
    dateFormat(val) {
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateFormat)
    },
    run(){
      this.form = {}
      if (this.$q.platform.is.ios){
        var windowReference = window.open()
      }
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.DateFrom = this.pDateFrom.format()
      this.form.DateTo = this.pDateTo.format()
      this.form.IdReport = this.IdReport
      axios.post(this.$apiUrlGo + "/excel/",
      qs.stringify(this.form),
      {
          responseType: 'blob', 
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data], {
              type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', "Excel.xlsx")
          document.body.appendChild(link)
          link.click()
      })
      .catch(e => {
        this.loading = false
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    deleteExcel(){ 

      this.$q.dialog({
        title: this.$t('global.DeleteExcelTemplate'),
        message: this.$t('global.DeleteExcelTemplateQuestion'),
        cancel: true
      }).onOk(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteExelReports"
        this.form.IdReport = this.IdReport
        axios.post(this.$apiUrlGo + "/excelreport/",
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            if(response.status == 200){ 
              this.loadReportList()
              this.IdReport = null 
              this.$q.notify({ message: this.$t('global.ExcelTemplateDeleted'), type: 'positive'})
            }
        })
        .catch(e => {
          this.loading = false
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    },
    setUpload(){
      this.formfields = []
      this.formfields.push({name: 'SessionId', value: this.$store.state.session.SessionId})
      this.formfields.push({name: 'ReportName', value: this.reportName})
      this.formfields.push({name: 'Type', value: this.selectType})
    },
    uploaded(){
      this.$q.notify({ message: this.$t('global.UploadOk'), type: 'positive'})
      this.loadReportList()
    },
    loadReportList(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetExelReports"
      axios.post(this.$apiUrlGo + "/excelreport/",
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then((response) => {
          if(response.status == 200){ 
            this.excelReportList = response.data
          }
      })
      .catch(e => {
        this.loading = false
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
  },
  watch: {
    reportName: function (newValue, oldValue) {
      this.setUpload()
    }
   },

   mounted () {
    this.loadReportList()
   },
}
</script>
<style scoped>
.content{
  padding: 5px;
}
.pageContent{
  padding: 10px;
}
.secondCard{
  margin-top: 10px;
}

</style>
